"use strict";
exports.__esModule = true;
var ChartBreakdownKey_1 = require("./ChartBreakdownKey");
var ChartBreakdown = /** @class */ (function () {
    function ChartBreakdown(_a) {
        var key = _a.key, values = _a.values, filterRequired = _a.filterRequired, display = _a.display;
        var _this = this;
        this.toJSON = function () { return ({
            key: _this.key,
            values: _this.values,
            filterRequired: _this.filterRequired,
            display: _this.display
        }); };
        this.key = key;
        this.values = values;
        this.filterRequired = filterRequired;
        this.display = display;
    }
    ChartBreakdown.fromJSON = function (json) {
        var _a = Object.assign({}, json), key = _a.key, values = _a.values, filterRequired = _a.filterRequired, display = _a.display;
        var _key = ChartBreakdownKey_1["default"].fromJSON(key);
        if (!Array.isArray(values) && values !== undefined)
            throw new Error('.values must be an array');
        if (typeof filterRequired !== 'boolean')
            throw new Error('.filterRequired must be a boolean');
        if (typeof display !== 'boolean')
            throw new Error('.display must be a boolean');
        return new ChartBreakdown({
            key: _key,
            values: values,
            filterRequired: filterRequired,
            display: display
        });
    };
    return ChartBreakdown;
}());
exports["default"] = ChartBreakdown;
